module.exports = __webpack_public_path__ + "static/media/Oliver.da18e256.jpg";